<template>
  <edit-survey-stage-expand-template
    :stage-title="stage.title"
    :stage-index="stageIndex"
    :stage-count="stageCount"
    :stage-id="stage.id"
    :loading="isLoading"
    @save="saveStage()"
    @delete="openDeleteStageDialog"
    @copy="copyStageCreator"
    @moveUp="$emit('moveUp', $event)"
    @moveDown="$emit('moveDown', $event)"
  >
    <template v-slot:form>

      <stage-form-template v-model="stage" :form_errors="errors" ref="stage_form"></stage-form-template>
    </template>
    <template v-slot:fields>
      <stage-fields ref="stage_fields" :stage-id="stage.id"></stage-fields>
    </template>
    <template v-slot:dialogs>
      <AddField
        v-if="open_add"
        :opened="open_add"
        :field-data="new_field_data"
        :survey-id="surveyId"
        :stage-id="stage.id"
        @close="closeAddStageField"
      ></AddField>
      <apply-dialog
        v-if="open_delete"
        :opened="open_delete"
        :get-text="() => `Вы уверены, что хотите удалить данный этап ?`"
        @close="deleteStageDetail"
      ></apply-dialog>
    </template>
    <template v-slot:actions-buttons>
      <v-btn
        v-if="stage.hasOwnProperty('id')"
        depressed
        @click="addStageField()"
      >
        Добавить поле
      </v-btn>
    </template>
  </edit-survey-stage-expand-template>
</template>

<script>

import StageFormTemplate from "@/modules/templates/survey/StageFormTemplate";
import StageFields from "@/modules/administrative/survey/components/edit/StageFields";
import AddField from "@/modules/administrative/survey/components/dialogs/AddField";
import EditSurveyStageExpandTemplate
  from "@/modules/templates/survey/edit/EditSurveyStageExpandTemplate";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import LoadingMixin from "@/mixins/LoadingMixin";
import {mapActions} from "vuex";

export default {
  name: "SurveyExpand",
  mixins: [LoadingMixin],
  components: {ApplyDialog, EditSurveyStageExpandTemplate, StageFormTemplate, AddField, StageFields},
  props: {
    value: {
      required: true,
    },
    stageIndex: {
      required: true,
    },
    stageCount: {
      required: true,
    },
    surveyId: {
      required: true
    },
  },
  data(){
    return {
      stage: this.value,
      open_add: false,
      open_delete: false,
      new_field_data: {},
      errors: {}
    }
  },
  watch: {
    value(){
      this.stage = this.value
    },
    stage: {
      deep: true,
      handler() {
        this.$emit('input', this.stage)
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions({
      updateStage: 'admin/updateStage',
      copyStage: 'admin/copyStage',
      deleteStage: 'admin/deleteStage',
    }),
    copyStageCreator(){
      this.copyStage({
        survey_id: this.surveyId,
        stage_id: this.stage.id,
        finalizer: () => {
          this.setNotLoading();
          this.$emit('update')
        },
        catcher: (error) => {
          this.setNotLoading();
          this.showError(error.survey[0])
        }
      })
    },
    saveFields(){
      if (this.$refs.stage_fields)
        this.$refs.stage_fields.saveFields();
    },
    validate(){
      if (this.$refs.stage_form)
        this.$refs.stage_form.validate();
    },
    loadFields(){
      this.$refs.stage_fields.loadFields()
    },
    saveStage(event=undefined, finalizer=()=>{}){
      this.errors = {}
      this.setLoading();
      this.updateStage({
        data: this.stage,
        survey_id: this.surveyId,
        finalizer: (data) => {
          finalizer(data);
          this.setNotLoading();
        },
        catcher: (error) => {
            this.setNotLoading();
            this.errors=(error)
        }
      })
      // this.saveFields()
    },
    addStageField(){
      this.open_add = true
    },
    closeAddStageField(){
      this.loadFields()
      this.open_add = false
    },
    openDeleteStageDialog(){
      this.open_delete = true
    },
    closeDeleteStageDialog(){
      this.open_delete = false
    },
    deleteStageDetail(apply){
      if (apply){
        this.setLoading();
        this.deleteStage({
          survey_id: this.surveyId,
          stage_id: this.stage.id,
          finalizer: () => {
            this.setNotLoading();
            this.$emit('deleted')
            // this.loadStages();
            this.closeDeleteStageDialog();
          },
            catcher: (error) => {
                this.setNotLoading();
                this.closeDeleteStageDialog();
                this.showError(error.value_choices)
            }
        })
      } else{
        this.closeDeleteStageDialog();
      }
    },
  },
}
</script>

<style scoped>

</style>
